import axios from 'axios'
import { Coords } from '../types'

const endpoint = 'https://api.mapbox.com/directions/v5/mapbox/driving'

interface MapboxDirectionsResponse {
  routes: { distance: number; duration: number }[]
}

export interface CarTripInfo {
  distance: number
  duration: number
  co2min: number
  co2max: number
}

export const getTripInfo = async (
  origCoords: Coords,
  destCoords: Coords,
): Promise<CarTripInfo | undefined> => {
  const accessToken = process.env.REACT_APP_MB_ACCESS || ''
  if (!accessToken) {
    console.error('Mapbox access token missing: set REACT_APP_MB_ACCESS')
    return
  }
  const coords = `${origCoords[0]},${origCoords[1]};${destCoords[0]},${destCoords[1]}`
  const url = `${endpoint}/${coords}`
  try {
    const response = (await axios({
      method: 'get',
      url,
      params: {
        access_token: accessToken,
        alternatives: 'false',
        overview: 'false',
        geometries: 'geojson',
      },
    })) as { data: MapboxDirectionsResponse }
    const routes = response.data.routes || []
    const distance = routes.length > 0 ? routes[0].distance : 0
    const duration = routes.length > 0 ? routes[0].duration : 0
    if (duration === 0 || distance === 0) {
      return
    }
    const co2min = Math.round((distance / 1000) * 100)
    const co2max = Math.round((distance / 1000) * 200)
    return {
      distance,
      duration,
      co2min,
      co2max,
    }
  } catch (error) {
    console.error(error)
  }
}
